<template>
  <v-app-bar app flat color="white" height="72" class="app-header">
    <v-btn
      v-if="isAuthenticated && $vuetify.breakpoint.smAndDown"
      color="primary"
      depressed
      height="40"
      width="40"
      min-width="40"
      class="menu-btn"
      @click="setSidebarDrawer(!sidebarDrawer)"
    >
      <v-icon>mdi-page-layout-sidebar-left</v-icon>
    </v-btn>
    <v-spacer />
    <!-- Languages -->
    <languages-menu />
    <v-divider v-if="isAuthenticated" vertical class="header-divider" />
    <!---User -->
    <v-btn
      v-if="isAuthenticated"
      text
      class="logout-btn"
      @click="logout"
    >
      <v-icon small left>mdi-logout</v-icon>
      {{ $vuetify.lang.t('$vuetify.LOG_OUT') }}
    </v-btn>
  </v-app-bar>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import 'flag-icon-css/css/flag-icon.css'
import LanguagesMenu from '@/components/commonComponents/LanguagesMenu'

export default {
  name: 'Header',
  components: {
    LanguagesMenu
  },

  computed: {
    ...mapState('app', ['sidebarDrawer']),
    ...mapGetters('authentication', ['isAuthenticated'])
  },

  methods: {
    ...mapMutations('app', ['setSidebarDrawer']),
    logout() {
      this.$store.dispatch('authentication/logout')
      this.$router.replace({ path: '/login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  background: #fff !important;
  border-bottom: 1px solid #ebe9e4;
}

.app-header ::v-deep .v-toolbar__content {
  padding: 16px 28px;
}

.header-divider {
  height: 24px;
  max-height: 24px;
  margin: 0 8px;
}

.logout-btn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 600;
}

.menu-btn {
  padding: 0;
  border-radius: 10px;
}
</style>
